// Importing necessary modules and components from Angular and third-party libraries
import { Component, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    currentPage = 'home';

    // Constructor to initialize dependencies
    constructor(titleService: Title, router: Router, activatedRoute: ActivatedRoute) {
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                var title = this.getTitle(router.routerState, router.routerState.root).join(' - ');
                if (this.currentPage == 'الخدمات الإلكترونية')
                    this.currentPage = 'home'
                titleService.setTitle(title);
            }
        });
    }

    // Function to recursively retrieves the title data from the Angular router state and its parent.
    getTitle(state, parent) {
        var data = [];
        if (parent && parent.snapshot.data && parent.snapshot.data.title) {
            data.push(parent.snapshot.data.title);

        }
        if (state && parent) {
            this.currentPage = parent.snapshot.data.title;
            data.push(... this.getTitle(state, state.firstChild(parent)));
        }
        return data;
    }


}